import script from "./TipTapToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TipTapToolbar.vue?vue&type=script&setup=true&lang=js"

import "./TipTapToolbar.vue?vue&type=style&index=0&id=5e41892b&scoped=true&lang=css"
import "./TipTapToolbar.vue?vue&type=style&index=1&id=5e41892b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e41892b"]])

export default __exports__